import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Restrained, Apple-like reveal: children marked with [data-reveal] fade up once
 * as the section scrolls into view. No rotation, no bounce.
 */
export function useReveal<T extends HTMLElement>(opts: { start?: string; stagger?: number } = {}) {
  const ref = useRef<T>(null);
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    const items = root.querySelectorAll('[data-reveal]');
    if (!items.length) return;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        items,
        { y: 28, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.7,
          ease: 'power2.out',
          stagger: opts.stagger ?? 0.08,
          scrollTrigger: { trigger: root, start: opts.start ?? 'top 78%', once: true },
        }
      );
    }, root);
    return () => ctx.revert();
  }, [opts.start, opts.stagger]);
  return ref;
}
